import { computed, type ComputedRef } from 'vue';
import { useHierarchy } from '@/store/hierarchy';

/**
 * The measurement chart's display name is brand-configurable via the hierarchy
 * (root node's inherited long name, e.g. "Measurement list" / "M-Chart").
 * Pluralized to match the other collection labels ("Products", "Orders", …).
 */
export function useMChartsLabel(): ComputedRef<string> {
  return computed(() => {
    const hierarchy = useHierarchy();
    const root = hierarchy.getRootNode();
    return root ? `${hierarchy.mChartName(root.id)}s` : 'Measurement lists';
  });
}
